import { useEffect } from 'react';

export const useLayoutEffects = () => {
  useEffect(() => {
    // sendMyMethod({ sample: "new" });
  }, []);

  return {};
};
